import { render, staticRenderFns } from "./TopicsContentPage.vue?vue&type=template&id=6537885b&scoped=true"
import script from "./TopicsContentPage.vue?vue&type=script&lang=js"
export * from "./TopicsContentPage.vue?vue&type=script&lang=js"
import style0 from "./TopicsContentPage.vue?vue&type=style&index=0&id=6537885b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6537885b",
  null
  
)

export default component.exports